export const magazineTableHeadings = ['Type', 'Cap', 'Lbs', 'Primary', 'Removed'];
